import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { Component, Input } from '@angular/core';
import { IconComponent, NotificationService, NotificationType } from '@ird/ng-base';

@Component({
  selector: 'shared-copy-content',
  templateUrl: './copy-content-button.component.html',
  styleUrls: ['./copy-content-button.component.scss'],
  imports: [CdkCopyToClipboard, IconComponent],
})
export class CopyContentButtonComponent {
  @Input() textToCopy: string;
  /**
   * Translation key of the notification shown after a successful copy. Defaults to the serial-number
   * message the first call sites used, so callers that copy something else can name their own.
   */
  @Input() copiedMessage = 'DEVICE_SERIAL_NR_TEXT_COPIED';

  constructor(private notificationService: NotificationService) {}

  onClipboardCopy(success: boolean) {
    if (success) {
      this.notificationService.showNotification({
        message: this.copiedMessage,
        type: NotificationType.Primary,
      });
    }
  }
}
